import styled from 'styled-components';
import getThemeTypography, { Typographies } from '../../utils/getThemeTypography';
export var BodyOneTypography = styled.label(getThemeTypography(Typographies.BODY1));
export var BodyTwoTypography = styled.label(getThemeTypography(Typographies.BODY2));
